<div class="logo-container">
    <img
        class="logo"
        alt="GoReact"
        src="https://staticassets.goreact.com/logo-goreact-dash-2022.svg">
    @if (isLTI) {
        <div class="lti-version">
            <span [attr.aria-label]="'logo-version' | translate : { versionNumber: version }">
                {{ version }}
            </span>
        </div>
    }
</div>
